import "./Footer.css";
import React, { useState } from "react";

const Footer = () => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalType) => {
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const renderModal = () => {
    if (!activeModal) return null;

    const modalContent = {
      why: {
        title: "Pourquoi ce site existe",
        content: (
          <>
            <p>
              Ce site a été conçu uniquement pour l'assemblée de Blois afin de
              faciliter les trajets vers nos réunions à Villebarou.
            </p>
            <p>
              Son but est très simple : permettre à ceux qui n'ont pas de moyen
              de transport de signaler leur besoin, et à ceux qui ont une
              voiture avec des places disponibles de proposer leur aide.
            </p>
            <p>
              Il ne s'agit pas d'un service public ni d'un site commercial, mais
              simplement d'un outil pratique interne, créé pour encourager
              l'entraide et la fraternité.
            </p>
            <div className="bible-quote">
              « Continuez de vous encourager mutuellement et de vous édifier les
              uns les autres. » — 1 Thessaloniciens 5:11
            </div>
            <p>
              Nous voulons que ce site reflète cet esprit d'entraide chrétienne,
              en rendant plus simple et plus joyeux le fait de se retrouver tous
              ensemble aux réunions.
            </p>
          </>
        ),
      },
      responsibility: {
        title: "Chacun responsable de son trajet",
        content: (
          <>
            <p>
              Ce site n'est qu'un outil de mise en relation entre proclamateurs.
            </p>
            <p>
              Chaque conducteur et chaque passager reste pleinement responsable
              de son trajet, de son véhicule et de sa sécurité.
            </p>
            <p>Les conducteurs proposent leur aide volontairement.</p>
            <p>
              L'assemblée n'assume aucune responsabilité en cas de retard,
              d'annulation, de panne ou d'accident : cela relève uniquement de
              la responsabilité personnelle de chacun.
            </p>
            <p>
              Nous comptons donc sur l'esprit chrétien de respect, ponctualité
              et bienveillance, afin que tout se passe dans les meilleures
              conditions.
            </p>
            <div className="bible-quote">
              « Que tout se fasse décemment et avec ordre. » — 1 Corinthiens
              14:40
            </div>
          </>
        ),
      },
      privacy: {
        title: "Respect de vos informations personnelles",
        content: (
          <>
            <p>Ce site est destiné uniquement à l'assemblée de Blois.</p>
            <p>
              Les informations que vous saisissez (nom, adresse de départ,
              nombre de places, etc.) servent exclusivement à organiser les
              trajets pour les réunions.
            </p>
            <p>
              Ces données ne sont pas revendues, ni utilisées à d'autres fins.
              Elles restent dans un cadre strictement privé et interne.
            </p>
            <p>Par souci de confidentialité :</p>
            <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
              <li>
                Seuls les éléments nécessaires à l'organisation du covoiturage
                sont partagés.
              </li>
              <li>
                Les adresses complètes ne sont visibles qu'au moment où un
                conducteur accepte un passager.
              </li>
              <li>
                Vos informations peuvent être supprimées si vous le demandez.
              </li>
            </ul>
            <p>Nous voulons respecter l'esprit de la Bible :</p>
            <div className="bible-quote">
              « Faites pour les autres ce que vous voulez qu'ils fassent pour
              vous. » — Matthieu 7:12
            </div>
          </>
        ),
      },
    };

    const currentModal = modalContent[activeModal];

    return (
      <div className="info-modal-overlay" onClick={closeModal}>
        <div className="info-modal" onClick={(e) => e.stopPropagation()}>
          <h2>{currentModal.title}</h2>
          {currentModal.content}
          <button className="close-btn" onClick={closeModal}>
            Fermer
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-buttons">
            <button className="footer-btn" onClick={() => openModal("why")}>
              Pourquoi ce site existe
            </button>
            <button
              className="footer-btn"
              onClick={() => openModal("responsibility")}
            >
              Chacun responsable de son trajet
            </button>
            <button className="footer-btn" onClick={() => openModal("privacy")}>
              Respect de vos informations personnelles
            </button>
          </div>
          <p style={{ color: "#6b7280", fontSize: "14px", margin: 0 }}>
            © 2025 - Assemblée de Blois - Outil de covoiturage interne
          </p>
        </div>
      </footer>
      {renderModal()}
    </>
  );
};

export default Footer;
